module.exports = __webpack_public_path__ + "media/images/iphone-12-revenue-1bef148c.png";